import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function GSTSettings() {
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => { api.get("/gst/settings").then(({ data }) => setData(data)); }, []);

    const save = async () => {
        setBusy(true);
        try {
            await api.put("/org/current", { gstin: data.organization.gstin, pan: data.organization.pan });
            toast.success("Saved");
        } finally { setBusy(false); }
    };

    if (!data) return <div className="p-8 text-muted-foreground">Loading…</div>;

    return (
        <>
            <PageHeader kicker="TAXES" title="GST Settings" subtitle="Organization tax configuration for Indian compliance." />
            <PageBody>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-card border border-border rounded-md p-6 space-y-4">
                        <h3 className="text-[17px] font-semibold">Registration</h3>
                        <div><Label>GSTIN</Label><Input className="mt-1.5" value={data.organization?.gstin || ""} onChange={(e) => setData({ ...data, organization: { ...data.organization, gstin: e.target.value } })} /></div>
                        <div><Label>PAN</Label><Input className="mt-1.5" value={data.organization?.pan || ""} onChange={(e) => setData({ ...data, organization: { ...data.organization, pan: e.target.value } })} /></div>
                        <div><Label>Legal name</Label><Input className="mt-1.5" value={data.organization?.legal_name || ""} readOnly /></div>
                        <Button onClick={save} disabled={busy}>{busy ? "Saving…" : "Save"}</Button>
                    </div>
                    <div className="bg-card border border-border rounded-md p-6 space-y-4">
                        <h3 className="text-[17px] font-semibold">GST Rates</h3>
                        <div className="grid grid-cols-5 gap-2">
                            {[0, 5, 12, 18, 28].map((r) => (
                                <div key={r} className="border border-border rounded-md p-3 text-center">
                                    <div className="text-2xl font-serif font-light">{r}%</div>
                                    <div className="text-[10px] uppercase tracking-[0.12em] text-muted-foreground mt-1">GST {r}</div>
                                </div>
                            ))}
                        </div>
                        <div className="text-[12.5px] text-muted-foreground border-t border-border pt-3">India's GST rate slabs. Cess and special rates can be added at item level.</div>
                    </div>
                </div>
            </PageBody>
        </>
    );
}
